import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MATERIAL_IMPORTS } from '../../../material/material-imports';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
import { CourseModel } from '@generativ/much-smarter-models';
import { Observable } from 'rxjs';
import { CourseService } from '../course.service';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule, ...MATERIAL_IMPORTS, SpinnerComponent],
  selector: 'app-course-list',
  templateUrl: './course-list.component.html',
  styleUrls: ['./course-list.component.scss']
})
export class CourseListComponent implements OnInit {

  courses: Observable<CourseModel[]>;
  loaded: boolean = false;

  constructor(private courseService: CourseService) { }

  ngOnInit() {
    this.courses = this.courseService.getCourses();
    this.loaded = true;
  }

  toggleActive(course) {
    this.loaded = false;
    this.courseService.toggleActive(course.id).subscribe(res => {
      alert(`Course '${course.title}' has been ${course.activated ? 'deactivated' : 'activated'}`);
      this.loaded = true;
    });
  }

}
